import {
  ClockCircleFilled,
  ContactsFilled, CrownFilled,
  DollarCircleFilled,
  FallOutlined,
  FileTextFilled,
  MailFilled,
  WarningFilled
} from '@ant-design/icons';

interface Props {
  iconType: string;
}

const NotificationsListItemIcon = ({ iconType }: Props):JSX.Element => {
  const defaultColorStyle = { color: 'rgba(0, 0, 0, 0.45)' };
  const testId = 'list-item-icon';

  // mapping is based on StreamNotificationRequest and StreamNotificationUser children usage
  // and used for non-default icons

  // TODO: create Ready to Award notification - ticket #186478987
  // 'ViewAwardTab' => (<CrownFilled style={{ color: 'rgba(250, 140, 22, 1)' }} />)

  // sometimes the type comes with additional info as a suffix, we don't need it to determine the type.
  const typeParts = iconType?.split('-') || [];
  const notificationIconType = typeParts[0];

  if ([
    'ViewSuggestedPrices'
  ].includes(notificationIconType)) return (<DollarCircleFilled data-testid={testId} style={defaultColorStyle} />);
  if ([
    'ViewRequestVendorsTab'
  ].includes(notificationIconType)) return (<FallOutlined data-testid={testId} style={defaultColorStyle} />);
  if ([
    'ViewRequestFormatReduceTime',
    'ViewRequestFormatAddTime'
  ].includes(notificationIconType)) return (<ClockCircleFilled data-testid={testId} style={defaultColorStyle} />);
  if ([
    'viewRequestDocumentsTab', 'ViewRequestDocuments'
  ].includes(notificationIconType)) return (<FileTextFilled data-testid={testId} style={defaultColorStyle} />);
  if ([
    'company_invitation'
  ].includes(notificationIconType)) return (<ContactsFilled data-testid={testId} style={defaultColorStyle} />);
  if ([
    'request_invitation'
  ].includes(notificationIconType)) return (<MailFilled data-testid={testId} style={defaultColorStyle} />);
  if ([
    'ViewAwardTab',
  ].includes(notificationIconType)) return (<CrownFilled data-testid={testId} style={defaultColorStyle}/>);

  // Default Icon
  // 'ViewVendorSurvey' => HighEvaluationCriteriaImpact
  // 'viewRequestVendorsTab' => UpdatedSupplierRecommendations
  // 'viewSupplierSurveyAsSupplier' => CompleteSupplierSurvey, LineItemsUpdated, UpdateSupplierSurvey
  // 'ViewRequestDashboardVendorSubmission' => VendorSubmissionReceived
  // 'VendorInviteBounced' => VendorInviteBounced
  // 'TeamInviteBounced' => TeamInviteBounced
  return (
    <WarningFilled data-testid={testId} style={defaultColorStyle} />
  );
};

export default NotificationsListItemIcon;
